export default () => [
  {
    label: 'Panel',
    route: { name: 'panel' },
    icon: 'fas fa-tv',
    auth: {
      roles: ['admin'],
    },
  },
  {
    label: 'Encargos',
    route: { name: 'charges' },
    icon: 'fas fa-clipboard-list',
    children: [{
      label: 'Ver encargos',
      route: { name: 'charges' },
      auth: {
        roles: ['admin', 'colaborador'],
      },
    },
    {
      label: 'Crear nuevo encargo',
      route: { name: 'charge' },
      exact: true,
      auth: {
        roles: ['admin', 'colaborador'],
      },
    },
    {
      label: 'Ver Anulados',
      route: { name: 'encargos-anulados' },
      exact: true,
      auth: {
        roles: ['admin', 'colaborador'],
      },
    },
    ],
  },
  {
    label: 'Agendar',
    route: { name: 'scheduleAssessorVisits' },
    icon: 'fas fa-calendar-alt',
    auth: { roles: ['tasador'] },
  },
  {
    label: 'Visitas',
    route: { name: 'visitsSchedule' },
    icon: 'fas fa-calendar-check',
    auth: { roles: ['tasador'] },
  },
  {
    label: 'Notificar Visitas',
    route: { name: 'visits' },
    icon: 'fas fa-calendar-check',
    auth: { roles: ['admin', 'colaborador'] },
  },
  {
    label: 'Incidencias',
    route: { name: 'incidencias' },
    icon: 'fas fa-exclamation-circle',
    auth: { roles: ['admin', 'colaborador', 'tasador'] },
    children: [{
      label: 'Ver incidencias',
      route: { name: 'incidencias' },
      auth: {
        roles: ['admin', 'colaborador', 'tasador'],
      },
    },
    {
      label: 'Ver retenidos',
      route: { name: 'retenidos' },
      auth: {
        roles: ['admin', 'colaborador', 'tasador'],
      },
    },
    {
      label: 'Ver reclamaciones',
      route: { name: 'revisiones' },
      auth: {
        roles: ['admin', 'colaborador', 'tasador'],
      },
    },
    ],
  },
  {
    label: 'Sucursales',
    route: { name: 'branches' },
    icon: 'fas fa-landmark',
    auth: {
      roles: ['admin', 'colaborador'],
    },
  },
  {
    label: 'Solicitantes',
    route: { name: 'clientes' },
    icon: 'fas fa-user',
    auth: { roles: ['admin', 'colaborador'] },
  },
  {
    label: 'Mi empresa',
    icon: 'fas fa-building',
    route: { name: 'delegations' },
    children: [{
      label: 'Empresas',
      route: { name: 'delegations' },
      icon: 'fas fa-users',
    },
    {
      label: 'Zonas',
      route: { name: 'zones' },
      icon: 'fas fa-map-marker-alt',
    },
    {
      label: 'Usuarios',
      route: { name: 'tasadores' },
      icon: 'fas fa-hand-holding-usd',
      auth: {
        roles: ['admin'],
      },
    },
    {
      label: 'Comerciales',
      route: { name: 'comerciales' },
      icon: 'fas- fa-hand-holding-usd',
    },
    {
      label: 'Clientes',
      route: { name: 'applicants' },
      icon: 'fas fa-user-tie',
    },

    {
      label: 'Tipos de trabajos',
      route: { name: 'jobs' },
      icon: 'fas fa-warehouse',
    },
    ],
    auth: { roles: ['admin', 'colaborador'] },
  },
  {
    label: 'Inmuebles',
    icon: 'fas fa-home',
    route: { name: 'properties' },
    auth: {
      roles: ['admin', 'colaborador'],
    },
    children: [{
      label: 'Tipos de Inmueble',
      route: { name: 'properties' },
      icon: 'fas fa-home',
      auth: {
        roles: ['admin', 'colaborador'],
      },
    },

    {
      label: 'Finalidad Inmuebles',
      route: { name: 'finalidadinmuebles' },
      icon: 'fas fa-home',
    },

    ],
    auth: { roles: ['admin', 'colaborador'] },
  },
];
